// extracted by mini-css-extract-plugin
export default {"dropdown":"ZNn8fpqd","dropdown__prefix":"u0_9mbdz","dropdownPrefix":"u0_9mbdz","prefix":"yhhTwepY","purple":"fP_2Gh_l"};